// extracted by mini-css-extract-plugin
export var blockedMessage = "_8o-3";
export var blockedOverlay = "_8o-1";
export var fadeIn = "_8o-2";
export var hereLink = "_8o-0";
export var slideUp = "_8o-4";